import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import inputStyles from '../../../ManagementPages.module.css';
import styles from '../../Patient.module.css';
import { setFormField } from '../../../../slicers/PatientSlice';
import { ExpandedArrow, CollapsedArrow } from '../../../../components/icons/Icons';
import FileUploadOrganization from '../../../new-organization/add-edit-organization/FileUploadOrganization';

const GroupInfoDetail= ({ setModal, setUpdateFn, setCancelFn, setProfile }) => {

    const dispatch = useDispatch();
    const patient = useSelector((state)=>state.patient);
    const {orgHierarchy, mrn, ssn, firstName, lastName, profilePictureURL} = patient;
   
    const initialState = {
        mrn: mrn || "",
        ssn: ssn || "",
        profilePictureURL: profilePictureURL || ""
    };
    const [updatingState, setUpdatingState] = useState(initialState);
    const [showSSN, setShowSSN] = useState(false);
    const [showUpdateButtons, setShowUpdateButtons] = useState(false);

    const handleChange = (e) => {
        const tempData = {...updatingState};
        tempData[e.target.id] = e.target.value;
        setUpdatingState(tempData);
        if (!showUpdateButtons) {
            setShowUpdateButtons(true);
        }
    };

    const handleUpdate = () => {
        const updatingInfo = {
            ...patient,
            mrn:updatingState.mrn,
            ssn:updatingState.ssn,
        };
        const updateFn = () => {
            setShowUpdateButtons(false);
            dispatch(setFormField({key:"mrn", value:updatingState.mrn}));
            dispatch(setFormField({key:"ssn", value:updatingState.ssn}));
            if (updatingState.hasOwnProperty("profilePictureURL")) {
                dispatch(setFormField({ key: "profilePictureURL", value: updatingState.profilePictureURL }));
            }
        };
        setUpdateFn(()=>updateFn);
        setCancelFn(()=>handleCancel);
        setModal({title:"Patient Info", message:`Update ${firstName} ${lastName}'s info?`, data:updatingInfo});
    };

    const handleCancel = () => {
        setUpdatingState(initialState);
        setShowUpdateButtons(false);
    };

    const handleProfileDrop = (acceptedFiles) => {
        const logoFile = acceptedFiles[0];
        if (logoFile) {
            const objectURL = URL.createObjectURL(logoFile);
            const tempData = {...updatingState};
            tempData["profilePictureURL"] = objectURL;
            setUpdatingState(tempData);
            setProfile(logoFile);
        }
        if (!showUpdateButtons) {
            setShowUpdateButtons(true);
        }
    };

    const TreeNode = ({node, level}) => {
        const [isExpanded, setIsExpanded] = useState(true);
        const nodeName = node.groupName || node.subGroupName || node.teamName;
        const children = node.subgroups || node.teams || [];
        const hasChildren = children.length > 0;

        return (
            <li>
                <div style={{paddingLeft: `${level*15}px`}} className={styles["group-list-name"]}>
                    {hasChildren &&
                        <span
                            style={{ cursor: "pointer", marginRight: "8px" }}
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? <ExpandedArrow /> : <CollapsedArrow />}
                        </span>
                    }
                    <span>{nodeName}</span>
                </div>
                {hasChildren && isExpanded &&
                    <ul className={styles["group-list-item"]}>
                        {children.map((child, index) => {
                            const childId = child.subGroupId || child.teamId + `_${index}`;
                            return (
                                <TreeNode
                                    key={childId}
                                    node={child}
                                    level={level+1}
                                />
                            );
                        })}
                    </ul>
                }
            </li>
        )
    };

    const groupsDisplay = () => {
        return (
            orgHierarchy.map((org)=>(
                <ul key={org.organizationId} style={{paddingLeft:"0"}} className={styles["group-list-item"]}>
                    {org.groups &&
                        org.groups.map((group, index)=>(
                            <TreeNode key={`${org.organizationId}-${index}`} node={group} level={0}/>
                        ))
                    }
                </ul>
            ))
        )
    };

    return (
        <div style={{display:"flex", flexDirection:"column", gap:"10px", justifyContent:"space-between"}}>
            {groupsDisplay()}
            <span className="subtitle-2" style={{color:"#4F4F4F"}}>Patient Info</span>
            <div className={inputStyles["styled-input-container"]}>
                <input
                    id="mrn"
                    value={updatingState.mrn}
                    onChange={handleChange}
                    style={{width:"300px"}}
                ></input>
                <label className={updatingState.mrn && inputStyles['filled']}>
                    Medical Record Number
                </label>
            </div>
            <div className={inputStyles["styled-input-container"]} style={{width:"300px"}}>
                <input
                    type={showSSN ? "text" : "password"}
                    maxLength="9"
                    id="ssn"
                    value={updatingState.ssn}
                    style={{width:"300px"}}
                    onChange={handleChange}
                ></input>
                <label className={updatingState.ssn && inputStyles['filled']}>
                    Social Security Number
                </label>
                <div className={inputStyles["styled-icon-container"]} onClick={() =>
                        setShowSSN((prev) => !prev)}
                >
                    {showSSN ? <FontAwesomeIcon icon="fa-regular fa-eye" className="eye-icon" size="lg"/>
                        : <FontAwesomeIcon icon="fa-regular fa-eye-slash" className="eye-icon" size="lg"/> }
                </div>
            </div>
            <div style={{width:"300px"}}>
                <FileUploadOrganization
                    fileType='image'
                    onDrop={handleProfileDrop}
                    imageURL={updatingState.profilePictureURL} 
                    acceptedTypes={"PNG,JPG | 8MB Max"}
                />
            </div>
            <div style={{display:"flex", columnGap:"10px"}}>
                <button variant='secondary' disabled={!showUpdateButtons} className={styles.SecondaryButton} onClick={handleCancel} >Cancel</button>
                <button variant='primary' disabled={!showUpdateButtons} className={styles.ModelButton} onClick={handleUpdate} >Save</button>
            </div>
        </div>
    );
}

export default GroupInfoDetail;